import {ProModal, ProModalProps} from 'Components/ProModal';
import ProForm from 'Components/ProForm';
import {Input, message} from 'antd';
import {DictForm, saveDict} from '../../service';
import {errorMessage} from 'Utils/common';
import {SimpleSwitch} from 'Features/Fields/SimpleSwitch';

interface DictModalProps extends ProModalProps {
    parentId?: string;
    onOk(): void;
    initialValues?: DictForm;
}

export function DictModal({
    parentId,
    initialValues,
    onOk,
    ...props
}: DictModalProps) {
    async function onFinish(data: DictForm) {
        try {
            await saveDict(data);
            message.success('保存成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const action = initialValues ? 'edit' : 'add';
    const actionName = action === 'edit' ? '修改' : '新增';
    const typeName = parentId ? '子项' : '维度';

    return (
        <ProModal.Form
            {...props}
            title={`${actionName}${typeName}`}
            width={700}
            onFinish={onFinish}
            formProps={{
                columns: 1,
                labelCol: {offset: 2, span: 6},
                wrapperCol: {offset: 1, span: 12},
            }}
            initialValues={initialValues || {parentId, status: '1'}}>
            <ProForm.Field name="id" hidden>
                <Input />
            </ProForm.Field>

            <ProForm.Field name="parentId" hidden>
                <Input />
            </ProForm.Field>

            <ProForm.Field
                name="name"
                required
                label={`${typeName}名称(中文)`}
                rules={[{required: true, message: '请输入${label}'}]}>
                <Input placeholder={`请输入${typeName}名称`} maxLength={150} />
            </ProForm.Field>

            <ProForm.Field name="nameEn" label={`${typeName}名称(英文)`}>
                <Input
                    placeholder={`请输入${typeName}名称(英文)`}
                    maxLength={150}
                />
            </ProForm.Field>

            <ProForm.Field
                name="code"
                required
                label={`${typeName}编码`}
                rules={[
                    {required: true, message: '请输入${label}'},
                    {
                        pattern: /^[a-zA-Z0-9_]+$/,
                        message: '只能输入字母数字下划线',
                    },
                ]}>
                <Input
                    placeholder="请输入维度编码"
                    maxLength={150}
                    disabled={action === 'edit'}
                />
            </ProForm.Field>

            <ProForm.Field name="remark" label="描述">
                <Input.TextArea placeholder="请输入描述" />
            </ProForm.Field>

            <ProForm.Field name="status" label="启用状态">
                <SimpleSwitch />
            </ProForm.Field>
        </ProModal.Form>
    );
}
